<template>
    
    <div id="list">
        <div id="card" style="display: flex;align-items: center;">
            <el-input
                class="search"
                type="text"
                size="mini"
                v-model="content"
                placeholder="搜索"
                prefix-icon="el-icon-search"
                clearable
            ></el-input>
            <addFd></addFd>
            <!-- <el-button class="searchBtn" size="mini" @click="addFriend" ><i class="fa fa-plus" aria-hidden="true"></i></el-button> -->
        </div>
        <!-- <ul v-if="currentList == '群聊'"> -->
        <!--群聊列表-->
        <!-- <p style="padding: 2px 4px; height: 20px">群聊列表</p>
            <li :class="{ active: currentSession ? '群聊' == currentSession.username : false }" v-on:click="changeCurrentSession(chatObj)">
                <img class="avatar" src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1268761962,3976237305&fm=26&gp=0.jpg" />
                <el-badge :is-dot="isDot[user.username + '#群聊']"><p class="name">群聊</p></el-badge>
            </li>
        </ul> -->
        <!--机器人-->
        <!-- <ul v-if="currentList == '机器人'">
            <p style="padding: 2px 4px; height: 20px">快来和机器人聊天吧！</p>
            <li
                :class="{ active: currentSession ? '机器人' == currentSession.username : false }"
                v-on:click="changeCurrentSession(robotObj)"
            >
                <img class="avatar" src="https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2548892998,499717296&fm=26&gp=0.jpg" />
                <p class="name">瓦力(智能回复)</p>
            </li>
        </ul> -->
        <!--用户列表-->
        <el-scrollbar wrap-class="userList">
            <ul v-if="currentList == '私聊'">
                <!-- <p style="padding: 2px 4px; height: 24px; margin-bottom: 4px;">消息列表</p> -->
                <li v-for="(item,index) in users" :style="{'background-color': indexOne == item.senderId ? '#c8c6c6' :''}" @click="changeCurrentSession(item)">
                    <!-- :class="[item.id === currentSession ? 'active':'']" -->
                    <div style="height: 50px;padding: 0 10px;display: flex;align-items: center;">
                        <el-badge :hidden="item.unReadNums == 0" :value="item.unReadNums" :max="99" class="item">
                            <el-image
                                class="avatar"
                                :src="item.headImage"
                                :alt="item.nickname"
                            >
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </el-badge>
                        <div style="display: flex;width: 96px;margin-left: 8px;flex-direction: column;justify-content: space-between;">
                            <span style="font-size: 18px;display: flex;align-items: center;"><span style="max-width: 90px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 500;">{{ item.nickName }}</span><span class="onLine" :style="{'background-color': item.isOnline==1 ? '#67C23A' : '#909399'}"></span></span>
                            <!-- <span style="font-size: 12px;width:120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.lastMessage }}</span> -->
                            <pre style="color: #708090;font-size: 14px;width:96px;height: 18px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" class="press" v-html="churst(item.lastMessage)"></pre>
                        </div>
                        <div style="height: 100%;display: flex;flex-direction: column;flex:1;justify-content: space-between;">
                            <!-- <div style="display: flex;align-items: end;">
                                <el-badge  style="display: flex;align-items: end;"
                                    :value="item.userStateId == 1 ? '在线' : '离线'"
                                    :type="item.userStateId == 1 ? 'danger' : 'info'"
                                ></el-badge>
                            </div> -->
                            <div style="flex: 1;display: flex;align-items: flex-end;justify-content: right;">
                                <el-dropdown @command="handleCommand">
                                    <span class="el-dropdown-link">
                                    <i class="el-icon-more"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="'delete',item">删除分类</el-dropdown-item>
                                        <el-dropdown-item :command="'jinyan',item">禁言</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div style="height:22px;font-weight: 500;font-size: 12px;display: flex;justify-content: right;">
                                {{item.lastMessageTime}}
                            </div>
                        </div>
                    </div>                    

                    <!-- <div style="display: flex; justify-content: space-between; height: 40px; padding: 0 10px">
                        <div style="flex: 1;display: flex;">
                            <el-badge :is-dot="isDot[user.username + '#' + item.username]" style="">
                                <el-image
                                    class="avatar"
                                    :preview-src-list="[item.headImage]"
                                    :src="item.headImage"
                                    :alt="item.nickname"
                                >
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </el-badge>
                            <div style="display: flex;flex-direction: column;justify-content: space-between;">
                                <span class="name">{{ item.nickName }}</span>
                                <span class="name">{{ item.lastMessage }}</span>
                            </div>
                        </div>
                        <div style="margin-top: 5px">
                            <el-badge
                                :value="item.userStateId == 1 ? '在线' : '离线'"
                                :type="item.userStateId == 1 ? 'danger' : 'info'"
                            ></el-badge>
                        </div>
                    </div> -->
                </li>
            </ul>
        </el-scrollbar>
    </div>
</template>

<script>
import { get } from '@/utils/request';
import { mapState } from 'vuex';
import addFd from '@/components/im/addfriend.vue';
import CircularJSON from 'circular-json';
export default {
    name: 'list',
    components: {
        addFd
    },
    data() {
        return {
            content:'',
            indexs:'',
            faceList: [  //表情包数据
                {
                    "url": "100.gif",
                    alt: "face[微笑]"
                }, {
                    "url": "101.gif",
                    alt: "face[伤心]"
                }, {
                    "url": "102.gif",
                    alt: "face[美女]"
                }, {
                    "url": "103.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "104.gif",
                    alt: "face[墨镜]"
                }, {
                    "url": "105.gif",
                    alt: "face[哭]"
                }, {
                    "url": "106.gif",
                    alt: "face[羞]"
                }, {
                    "url": "107.gif",
                    alt: "face[哑]"
                }, {
                    "url": "108.gif",
                    alt: "face[睡]"
                }, {
                    "url": "109.gif",
                    alt: "face[哭]"
                }, {
                    "url": "110.gif",
                    alt: "face[囧]"
                }, {
                    "url": "111.gif",
                    alt: "face[怒]"
                }, {
                    "url": "112.gif",
                    alt: "face[调皮]"
                }, {
                    "url": "113.gif",
                    alt: "face[笑]"
                }, {
                    "url": "114.gif",
                    alt: "face[惊讶]"
                }, {
                    "url": "115.gif",
                    alt: "face[难过]"
                }, {
                    "url": "116.gif",
                    alt: "face[酷]"
                }, {
                    "url": "117.gif",
                    alt: "face[汗]"
                }, {
                    "url": "118.gif",
                    alt: "face[抓狂]"
                }, {
                    "url": "119.gif",
                    alt: "face[吐]"
                }, {
                    "url": "120.gif",
                    alt: "face[笑]"
                }, {
                    "url": "121.gif",
                    alt: "face[快乐]"
                }, {
                    "url": "122.gif",
                    alt: "face[奇]"
                }, {
                    "url": "123.gif",
                    alt: "face[傲]"
                },
                {
                    "url": "124.gif",
                    alt: "face[饿]"
                }, {
                    "url": "125.gif",
                    alt: "face[累]"
                }, {
                    "url": "126.gif",
                    alt: "face[吓]"
                }, {
                    "url": "127.gif",
                    alt: "face[汗]"
                }, {
                    "url": "128.gif",
                    alt: "face[高兴]"
                }, {
                    "url": "129.gif",
                    alt: "face[闲]"
                }, {
                    "url": "130.gif",
                    alt: "face[努力]"
                }, {
                    "url": "131.gif",
                    alt: "face[骂]"
                }, {
                    "url": "132.gif",
                    alt: "face[疑问]"
                }, {
                    "url": "133.gif",
                    alt: "face[秘密]"
                }, {
                    "url": "134.gif",
                    alt: "face[乱]"
                }, {
                    "url": "135.gif",
                    alt: "face[疯]"
                }, {
                    "url": "136.gif",
                    alt: "face[哀]"
                }, {
                    "url": "137.gif",
                    alt: "face[鬼]"
                }, {
                    "url": "138.gif",
                    alt: "face[打击]"
                }, {
                    "url": "139.gif",
                    alt: "face[bye]"
                }, {
                    "url": "140.gif",
                    alt: "face[汗]"
                }, {
                    "url": "141.gif",
                    alt: "face[抠]"
                }, {
                    "url": "142.gif",
                    alt: "face[鼓掌]"
                }, {
                    "url": "143.gif",
                    alt: "face[糟糕]"
                }, {
                    "url": "144.gif",
                    alt: "face[恶搞]"
                }, {
                    "url": "145.gif",
                    alt: "face[什么]"
                }, {
                    "url": "146.gif",
                    alt: "face[什么]"
                }, {
                    "url": "147.gif",
                    alt: "face[累]"
                },
                {
                    "url": "148.gif",
                    alt: "face[看]"
                }, {
                    "url": "149.gif",
                    alt: "face[难过]"
                }, {
                    "url": "150.gif",
                    alt: "face[难过]"
                }, {
                    "url": "151.gif",
                    alt: "face[坏]"
                }, {
                    "url": "152.gif",
                    alt: "face[亲]"
                }, {
                    "url": "153.gif",
                    alt: "face[吓]"
                }, {
                    "url": "154.gif",
                    alt: "face[可怜]"
                }, {
                    "url": "155.gif",
                    alt: "face[刀]"
                }, {
                    "url": "156.gif",
                    alt: "face[水果]"
                }, {
                    "url": "157.gif",
                    alt: "face[酒]"
                }, {
                    "url": "158.gif",
                    alt: "face[篮球]"
                }, {
                    "url": "159.gif",
                    alt: "face[乒乓]"
                }, {
                    "url": "160.gif",
                    alt: "face[咖啡]"
                }, {
                    "url": "161.gif",
                    alt: "face[美食]"
                }, {
                    "url": "162.gif",
                    alt: "face[动物]"
                }, {
                    "url": "163.gif",
                    alt: "face[鲜花]"
                }, {
                    "url": "164.gif",
                    alt: "face[枯]"
                }, {
                    "url": "165.gif",
                    alt: "face[唇]"
                }, {
                    "url": "166.gif",
                    alt: "face[爱]"
                }, {
                    "url": "167.gif",
                    alt: "face[分手]"
                }, {
                    "url": "168.gif",
                    alt: "face[生日]"
                }, {
                    "url": "169.gif",
                    alt: "face[电]"
                }, {
                    "url": "170.gif",
                    alt: "face[炸弹]"
                }, {
                    "url": "171.gif",
                    alt: "face[刀子]"
                },
                {
                    "url": "172.gif",
                    alt: "face[足球]"
                }, {
                    "url": "173.gif",
                    alt: "face[瓢虫]"
                }, {
                    "url": "174.gif",
                    alt: "face[翔]"
                }, {
                    "url": "175.gif",
                    alt: "face[月亮]"
                }, {
                    "url": "176.gif",
                    alt: "face[太阳]"
                }, {
                    "url": "177.gif",
                    alt: "face[礼物]"
                }, {
                    "url": "178.gif",
                    alt: "face[抱抱]"
                }, {
                    "url": "179.gif",
                    alt: "face[拇指]"
                }, {
                    "url": "180.gif",
                    alt: "face[贬低]"
                }, {
                    "url": "181.gif",
                    alt: "face[握手]"
                }, {
                    "url": "182.gif",
                    alt: "face[剪刀手]"
                }, {
                    "url": "183.gif",
                    alt: "face[抱拳]"
                }, {
                    "url": "184.gif",
                    alt: "face[勾引]"
                }, {
                    "url": "185.gif",
                    alt: "face[拳头]"
                }, {
                    "url": "186.gif",
                    alt: "face[小拇指]"
                }, {
                    "url": "187.gif",
                    alt: "face[拇指八]"
                }, {
                    "url": "188.gif",
                    alt: "face[食指]"
                }, {
                    "url": "189.gif",
                    alt: "face[ok]"
                }, {
                    "url": "190.gif",
                    alt: "face[情侣]"
                }, {
                    "url": "191.gif",
                    alt: "face[爱心]"
                }, {
                    "url": "192.gif",
                    alt: "face[蹦哒]"
                }, {
                    "url": "193.gif",
                    alt: "face[颤抖]"
                }, {
                    "url": "194.gif",
                    alt: "face[怄气]"
                }, {
                    "url": "195.gif",
                    alt: "face[跳舞]"
                },
                {
                    "url": "196.gif",
                    alt: "face[发呆]"
                }, {
                    "url": "197.gif",
                    alt: "face[背着]"
                }, {
                    "url": "198.gif",
                    alt: "face[伸手]"
                }, {
                    "url": "199.gif",
                    alt: "face[耍帅]"
                }, {
                    "url": "200.png",
                    alt: "face[微笑]"
                }, {
                    "url": "201.png",
                    alt: "face[生病]"
                }, {
                    "url": "202.png",
                    alt: "face[哭泣]"
                }, {
                    "url": "203.png",
                    alt: "face[吐舌]"
                }, {
                    "url": "204.png",
                    alt: "face[迷糊]"
                }, {
                    "url": "205.png",
                    alt: "face[瞪眼]"
                }, {
                    "url": "206.png",
                    alt: "face[恐怖]"
                }, {
                    "url": "207.png",
                    alt: "face[忧愁]"
                }, {
                    "url": "208.png",
                    alt: "face[眨眉]"
                }, {
                    "url": "209.png",
                    alt: "face[闭眼]"
                }, {
                    "url": "210.png",
                    alt: "face[鄙视]"
                }, {
                    "url": "211.png",
                    alt: "face[阴暗]"
                }, {
                    "url": "212.png",
                    alt: "face[小鬼]"
                }, {
                    "url": "213.png",
                    alt: "face[礼物]"
                }, {
                    "url": "214.png",
                    alt: "face[拜佛]"
                }, {
                    "url": "215.png",
                    alt: "face[力量]"
                }, {
                    "url": "216.png",
                    alt: "face[金钱]"
                }, {
                    "url": "217.png",
                    alt: "face[蛋糕]"
                }, {
                    "url": "218.png",
                    alt: "face[彩带]"
                }, {
                    "url": "219.png",
                    alt: "face[礼物]"
                }, 
			],
            dialogVisible: false,
            user: {
                username: ''
            },
            currentList: '私聊',
            isDot: {},
            chatObj: { username: '群聊', nickname: '群聊' }, //群聊实体对象（为方法复用而构造，对于User对象）
            robotObj: {
                username: '机器人',
                nickname: '机器人',
                userProfile: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2548892998,499717296&fm=26&gp=0.jpg'
            }
        };
    },
    computed:{
        users(){
            // console.log(this.$store.state.newChat.chatList,"为什么")
            if(this.$store.state.newChat.chatList == null || this.$store.state.newChat.chatList == undefined){
                return this.$store.state.newChat.chatList
            }
            let arr = JSON.parse(JSON.stringify(this.$store.state.newChat.chatList))
            for (let iterator of arr) {
                // console.log(iterator)
                iterator.lastMessageTime = this.time(iterator.lastMessageTime)
            }
            // console.log(arr)
            return arr.filter(item => item.nickName.indexOf(this.content)>=0)
        },
        indexOne(){
            return this.$store.state.newChat.chatUserInfo.senderId
        }
    },
    created(){
        console.log(this.users)
    },
    methods: {
        // changeCurrentSession(currentSession) {
        //     console.log(currentSession)
        //     this.$store.commit('chat/changeCurrentSession', currentSession);
        // }
        addFriend(){
            // console.log("是我没错，寻找好友")
            this.dialogVisible = true
        },
        churst(processedMessage){
            if(!processedMessage){
                return ' ';
            }
            this.faceList.forEach(emoji => {
                let str = emoji.alt
                let result = str.replace(/face\[/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                result = result.replace(/\]/g, ''); // 使用正则表达式匹配方括号及其内容，替换为空字符串
                // console.log(result)
                let altPattern = new RegExp(emoji.alt.replace(/(face\[(.*?)\])/g, 'face\\[$2\\]'), 'g');
                // console.log(altPattern)
                // console.log(altPattern,emoji,processedMessage.replace(altPattern, `<img src="${emoji.url}" alt="${result}">`))
                processedMessage = processedMessage.replace(altPattern, `<img style="display: inline-block;width: 16px;height: 16px;" src="${this.getImageSrc(emoji.url)}" alt="${result}">`);
            });
            return processedMessage;
            // let altPattern = new RegExp(/face\[(.*?)\]/g);
            // console.log(altPattern,emoji,processedMessage.replace(altPattern, `<img src="${emoji.url}" alt="${result}">`))
            // val = val.replace(altPattern, `<img style="display: inline-block;width: 20px;height: 20px;" class="custom-img" src="${this.getImageSrc(emoji.url)}" alt="${result}">`);
            // return val;
        },
        getImageSrc(url) {
            return require(`@/assets/img/emoji/${url}`);
        },
        changeCurrentSession(currentSession) {
            this.indexs = currentSession.senderId
            // console.log(currentSession)
            let sender = JSON.parse(localStorage.getItem('sender')).senderId
            let array = this.$store.state.newChat.chatList
            let objs = CircularJSON.parse(localStorage.getItem(`msgList_${sender}_${this.indexs}`))
            // console.log(objs,"你看有没有",`msgList_${sender}_${this.indexs}`)
            let obj = objs.receiver
            get(`/im/user/get`,{id: currentSession.senderId}).then((res)=>{
                if(res.success){
                    array.forEach(item => {
                        if(item.senderId == currentSession.senderId){
                            item.nickname = res.user.userNickname
                            item.headImage = res.user.userHeader
                            obj.nickName = res.user.userNickname
                            obj.headImage = res.user.userHeader
                            objs.receiver = obj
                            localStorage.setItem(`chatList_${sender}`,JSON.stringify(array))
                            localStorage.setItem(`msgList_${sender}_${this.indexs}`,CircularJSON.stringify(objs))
                            return
                        }
                    })
                }
            })
            this.$store.commit('newChat/setChatUserInfo', currentSession);
        },
        handleCommand(val,val1){
            // console.log(val,val1.$attrs.item)
           if(val == 'delete'){
                this.$confirm('确定删除此聊天记录吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.$store.commit('newChat/deleteChatList', val1.$attrs.item.senderId);
                    })
                    .catch(() => {});
                return
           }
           if(val == 'jinyan'){
                this.$confirm('确定禁言此用户吗？', '提示', {
                        type: 'warning'
                    })
                        .then(() => {
                            get(`/im/user/forbidUser`,{userId:val1.$attrs.item.senderId}).then(res => {
                                if (res.success) {
                                    this.$message.success('禁言成功');
                                } else {
                                    this.$message.error('禁言失败');
                                }
                            });
                        })
                        .catch(() => {});
                return
           }
            
        },
        time(date) {
            if (date) {
                date = new Date(date);
            }
            //当前的时间
            let currentDate = new Date();
            //与当前时间的日期间隔
            // let timeInterval = currentDate.getDate() - date.getDate();
            let timeInterval = Math.floor((new Date(currentDate.toDateString()).getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
            //星期数组
            let weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            //时间范围（上下午）
            // let timeRange = '';
            // if (date.getHours() > 12) {
            //     timeRange = '';
            // }
            //如果与当前时间同日
            // console.log(timeInterval,date.getFullYear(),currentDate.getFullYear())
            if (date.getMonth() == currentDate.getMonth() && date.getDate() == currentDate.getDate()) {
                return `${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
                // return `${timeRange}${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;
            }
            //在当前时间同一年且日期间隔在7天内
            if (date.getFullYear() == currentDate.getFullYear() && timeInterval <= 5 && timeInterval >= 0) {
                //当前时间的前一天
                if (timeInterval == 0) {
                    return `昨天 ${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}`;// ${timeRange}${date.getHours()}:${date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes()}
                } else {
                    return `${weekdays[date.getDay()]}`;// ${timeRange} ${date.getHours()}:${date.getMinutes()}
                }
            }
            //如果日期超过7天
            else
                return `${date.getFullYear()}-${
                    date.getMonth() + 1
                }-${date.getDate()}`;// ${timeRange}  ${date.getHours()}:${date.getMinutes()}
        }
    }
};
</script>

<style lang="scss" scoped>
#list {
    flex:1;
    ul {
        margin-left: 0px;
        // padding-left: 2px;
        // margin-left: 2px;
    }
    li {
        padding-top: 10px;
        padding-left: 2px;
        padding-bottom: 10px;
        //padding-right: 40px;
        //border-bottom: 1px solid #292C33;
        list-style: none;
        // background-color: #fff;
        border-bottom: 1px solid #D1CDC9;
        cursor: pointer;
        &:hover {
            background-color: #d8d6d6;
        }
    }
    li.active {
        /*注意这个是.不是冒号:*/
        background-color: #c8c6c6;
    }
    .avatar {
        border-radius: 23px;
        width: 46px;
        height: 46px;
        vertical-align: middle;
    }
    .name {
        display: inline-block;
        margin-left: 15px;
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .stateItem {
        //在线状态的样式
        /*position: absolute;*/
        /*left: 160px;*/
        //margin-left: 100px;
        //margin-right: 10px;
    }
    .userList {
        height: 100%;
    }
}
.onLine{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-left: 5px;
}
::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
    height: calc(100vh - 109px);
}
::v-deep .is-fixed{
    position: absolute;
    top: 5px;
    right: 16px;
}
::v-deep .el-badge__content{
    background-color: #F56C6C;
    border-radius: 67px;
    color: #FFF;
    display: inline-block;
    font-size: 10px;
    height: 16px;
    line-height: 16px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #FFF;
}
// ::v-deep .el-scrollbar__wrap.default-scrollbar__wrap {
//     overflow: hidden;
// }
</style>
<style lang="scss" scoped>
#card {
    // padding: 12px;
    height: 50px;
    display: flex;
    justify-content: center;
    background-color: #eee;
    // margin-bottom: 5px;
    border-bottom: 1px solid #c7d2db;
    .avatar {
        width: 40px;
        height: 40px;
        vertical-align: middle; /*这个是图片和文字居中对齐*/
    }
    .name {
        display: inline-block;
        padding: 10px;
        margin-bottom: 15px;
        font-size: 16px;
    }
    .search {
        width: 170px;
        height: 30px;
        line-height: 30px;
        // padding: 0 10px;
        border: 0;
        border-radius: 4px;
        outline: none; /*鼠标点击后不会出现蓝色边框*/
        color: #fff;
        margin-right: 10px;
    }
    .searchBtn {
        background-color: #dbd9d8;
        border: 0;
        margin-left: 3px;
    }
}
</style>
<style>
/*当前组件的el-input样式设置*/
#card .el-input__inner {
    background-color: #dbd9d8;
    outline: none; /*鼠标点击后不会出现蓝色边框*/
}
</style>
